<template>
  <div class="p-3 mb-6" id="report-income">
    <div class="flex flex-col p-4 items-center justify-center">
      <div
        class="w-full max-w-4xl bg-white rounded-lg shadow-lg hover:shadow-2xl border border-gray-200 transform hover:-translate-y-1 transition duration-200 p-6 flex flex-col items-center justify-center"
      >
        <h1 class="text-2xl font-semibold mb-2">Tendencia de Ingresos</h1>
        <Chart :options="chartOptions" />
      </div>
    </div>
    <div class="flex flex-row gap-4 p-4 items-center justify-center">
      <div
        class="sm:w-full w-1/2 max-w-4xl bg-white rounded-lg shadow-lg hover:shadow-2xl border border-gray-200 transform hover:-translate-y-1 transition duration-200 p-6 flex flex-col items-center justify-center"
      >
        <h1 class="text-2xl font-semibold mb-2">Ingresos por Categoría</h1>
        <Chart :options="chartSalesByCategory" />
      </div>
      <div
        class="sm:w-full w-1/2 max-w-4xl bg-white rounded-lg shadow-lg hover:shadow-2xl border border-gray-200 transform hover:-translate-y-1 transition duration-200 p-6 flex flex-col items-center justify-center"
      >
        <h1 class="text-2xl font-semibold mb-2">
          Top 5 Productos Más Vendidos
        </h1>
        <Chart :options="chartTopProducts" />
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";
import { Chart } from "highcharts-vue";
export default {
  name: "SummaryReports",
  components: {
    Chart,
  },
  props: {
    topProductsSales: {
      type: Array,
      required: true,
      default: () => [],
    },
    monthsSalesServices: {
      type: Array,
      required: true,
      default: () => [],
    },
    monthsSalesProducts: {
      type: Array,
      required: true,
      default: () => [],
    },
    monthsIncomes: {
      type: Array,
      required: true,
      default: () => [],
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "area",
          height: 350,
          width: this.widthChart,
          reflow: true,
        },
        title: {
          text: null, // Oculta el título del gráfico
        },
        xAxis: {
          categories: this.monthNames(),
          title: {
            text: "Mes",
          },
        },
        yAxis: {
          title: {
            text: "Monto",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        series: [
          {
            name: "Ingresos",
            data: this.monthsIncomes,
            color: "#22c55e", // verde
            fillOpacity: 0.5,
          },
        ],
      },
      chartSalesByCategory: {
        chart: {
          type: "column",
          height: 350,
          width: 400,
          reflow: true,
        },
        title: {
          text: null, // Oculta el título del gráfico
        },
        xAxis: {
          categories: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
          ], // Aquí irán las categorías
          title: {
            text: "Categorías",
          },
        },
        yAxis: {
          title: {
            text: "Monto",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        series: [
          {
            name: "Servicios",
            data: this.monthsSalesServices,
            color: "#3b82f6", // azul
          },
          {
            name: "Productos",
            data: this.monthsSalesProducts,
            color: "#22c55e", // verde
          },
        ],
      },
      chartTopProducts: {
        chart: {
          type: "bar",
          height: 350,
          width: 400,
          reflow: true,
        },
        title: {
          text: null, // Oculta el título del gráfico
        },
        xAxis: {
          categories: this.getTopProductsNames(), // Aquí irán los nombres de los productos
          title: {
            text: "Productos",
          },
        },
        yAxis: {
          title: {
            text: "Piezas Vendidas",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        series: [
          {
            name: "Piezas Vendidas",
            data: this.getTopProductsData(), // Aquí irán los datos de los productos más vendidos
            color: "#f59e0b", // amarillo
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    monthNames() {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return months.slice(0, this.monthsIncomes.length);
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    getTopProductsNames() {
      return this.topProductsSales.map((product) => product.productName);
    },
    getTopProductsData() {
      return this.topProductsSales.map((product) => product.totalQuantity);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
